import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-circular-progress',
    templateUrl: './circular-progress.component.html',
    styleUrls: ['./circular-progress.component.scss'],
})
export class CircularProgressComponent implements OnInit {
    @Input() value: number = 0;
    @Input() size: number = 80;
    @Input() strokeWidth: number = 6;
    @Input() label: string | null = null;
    @Input() showPercentage: boolean = true;
    @Input() backgroundColor: string = 'rgba(255, 255, 255, 0.2)';
    @Input() animationDuration: number = 1.5;

    strokeColor: string = '#ffffff';
    radius: number;
    circumference: number;
    strokeDashoffset: number;

    ngOnInit(): void {
        this.calculateProgress();
        this.strokeColor = this.getColor();
    }

    ngOnChanges(): void {
        this.calculateProgress();
    }

    private getColor(): string {
        switch (true) {
            case this.value >= 75:
                return '#4CAF50'; // Green
            case this.value >= 50:
                return '#FFC107'; // Amber
            case this.value >= 25:
                return '#FF9800'; // Orange
            default:
                return '#F44336'; // Red
        }
    }

    private calculateProgress(): void {
        // Calculate radius (size/2 - strokeWidth/2)
        this.radius = (this.size - this.strokeWidth) / 2;

        // Calculate circumference (2 * PI * radius)
        this.circumference = 2 * Math.PI * this.radius;

        // Calculate stroke-dashoffset based on value
        const progress = Math.min(Math.max(this.value, 0), 100);
        this.strokeDashoffset = this.circumference - (progress / 100) * this.circumference;
    }

    get center(): number {
        return this.size / 2;
    }

    get displayValue(): string {
        return this.showPercentage ? `${this.value}%` : `${this.value}`;
    }
}
